import { colors } from '@/theme/colors';

interface BrandmarkSunsetProps {
  className?: string;
}

export default function BrandmarkSunset({ className }: BrandmarkSunsetProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM7.88512 15.5651C8.12512 15.5651 8.28512 15.3201 8.32512 15.2501L11.4051 10.0001L8.32512 4.76006C8.28512 4.68006 8.12512 4.44506 7.88512 4.44506H5.79512C5.64012 4.44006 5.50512 4.56006 5.49512 4.71506C5.50012 4.76006 5.51012 4.80006 5.53512 4.84006L8.57512 10.0001L5.53512 15.1701C5.51512 15.2101 5.50012 15.2501 5.50012 15.2951C5.51012 15.4501 5.64512 15.5701 5.80012 15.5651H7.88512ZM12.1151 15.5651H14.2001C14.3551 15.5701 14.4901 15.4551 14.5001 15.2951C14.5001 15.2501 14.4851 15.2051 14.4601 15.1651L11.8951 10.7951L10.4801 13.2051L11.6751 15.2501C11.7151 15.3251 11.8751 15.5651 12.1151 15.5651ZM11.8951 9.20006L14.4651 4.82006C14.4851 4.78506 14.5001 4.74506 14.5001 4.70006C14.4901 4.54506 14.3551 4.43506 14.2001 4.43506H12.1151C11.8751 4.43506 11.7151 4.68006 11.6751 4.75006L10.4801 6.79006L11.8951 9.20006Z"
        fill="url(#paint0_linear_4132_39789)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4132_39789"
          x1="2.2963"
          y1="25.4599"
          x2="26.3076"
          y2="-6.23189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.sunsetBlue} />
          <stop offset="0.643637" stopColor={colors.sunsetPurple} />
          <stop offset="0.893108" stopColor={colors.sunsetPink} />
        </linearGradient>
      </defs>
    </svg>
  );
}
